import dayjs from "dayjs";

import type { ILineChartData } from "pro-features/components/Chart/src/components/PeriodOverPeriodChart/PoPChartTypes";

import markerWithDashedLinePerPointChartConfig from "../../configs/series/markerWithDashedLinePerPointChartConfig";

export const processDataForLineInChart = (title: string, color: string, recordsData: ILineChartData[]) => {
    // We want to pass the linechart data into the lowConfidence chart config
    // this way we "augment" our data with confidence representation
    const chartDataWithConfidence = markerWithDashedLinePerPointChartConfig({
        data: recordsData.map((rec) => [rec.x, rec.y, rec.confidenceData]),
        color: color,
        isDataSingleSeries: true,
    });

    // After augmenting the chart data with confidence,
    // we want to add our original data fields to the augmented data.
    (chartDataWithConfidence as FixmeType)["data"] = (chartDataWithConfidence as FixmeType)["data"].map(
        (rec: FixmeType, index: number) => {
            return {
                originalX: recordsData[index]["originalX"],
                change: recordsData[index]["change"],
                ...rec,
            };
        },
    );

    return {
        name: title,
        color: color,
        marker: { symbol: "circle" },
        ...chartDataWithConfidence,
    };
};

export const normalizeChartXData = (value: FixmeType) => {
    const date = new Date(value);

    if (date.toString() !== "Invalid Date") {
        return dayjs.utc(value).unix() * 1000;
    }

    return value;
};
